import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import Fleet from './components/Fleet';
import Experiences from './components/Experiences';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import WhatsAppButton from '../../components/WhatsAppButton';
import CartButton from '../../components/CartButton';

export default function Home() {
  return (
    <div className="min-h-screen" style={{ fontFamily: 'Montserrat, sans-serif' }}>
      <Navbar />
      <Hero />
      <Services />
      <Fleet />
      <Experiences />
      <Testimonials />
      <Contact />
      <Footer />
      <WhatsAppButton />
      <CartButton />
    </div>
  );
}